import { Component, OnInit } from '@angular/core';
import { SupplierMetricsService } from '../../../../services/gamification/supplier-metrics.service';
import { SupplierMetricsDTO } from '../../../../interfaces/gamification/supplier-metrics.dto';
import moment, { isDate } from 'moment';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export enum MetricRange {
  Weekly,
  Monthly,
  Custom,
}

const DateFormat = 'DD MMM YYYY';

@Component({
  selector: 'gamification-metrics',
  templateUrl: 'gamification-metrics.component.html',
  styleUrls: ['gamification-metrics.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
})
export class GamificationMetricsComponent implements OnInit {
  constructor(
    private metricService: SupplierMetricsService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    this.matIconRegistry.addSvgIcon(
      'date_check_in',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/images/gamification/calendar.svg'),
    );
  }

  metricRange = MetricRange;

  metrics: SupplierMetricsDTO[];
  customRangeMetrics: SupplierMetricsDTO;

  loadingData = true;
  todayDate: Date = new Date();
  weekDate: string;
  monthDate: string;

  customRangeStart: Date;
  customRangeEnd: Date;

  async ngOnInit() {
    this.customRangeStart = moment().clone().startOf('month').toDate();
    this.customRangeEnd = moment().clone().endOf('month').toDate();

    await this.loadMetrics();
  }

  async loadMetrics() {
    this.loadingData = true;

    let currentDate = moment();
    let weekStart = currentDate.clone().startOf('isoWeek');
    let weekEnd = currentDate.clone().endOf('isoWeek');
    this.weekDate = `${weekStart.format(DateFormat)} - ${weekEnd.format(DateFormat)}`;
    this.monthDate = currentDate.format('MMMM');

    this.metrics = [];

    await this.metricService.getWeeklyMetrics().then((res) => {
      this.metrics[0] = res;
    });

    await this.metricService.getMonthlyMetrics().then((res) => {
      this.metrics[1] = res;
    });

    await this.loadCustomRangeMetrics();

    this.loadingData = false;
  }

  async loadCustomRangeMetrics() {
    if (!this.customRangeStart || !this.customRangeEnd) {
      return;
    }

    this.loadingData = true;

    await this.metricService
      .getCustomRangeMetrics(this.customRangeStart.toISOString(), this.customRangeEnd.toISOString())
      .then((res) => {
        this.customRangeMetrics = res;
      });

    this.loadingData = false;
  }

  async customRangeStartChange(event: MatDatepickerInputEvent<Date>) {
    if (this.customRangeStart == event.value) return;

    this.customRangeStart = event.value;
  }
  async customRangeEndChange(event: MatDatepickerInputEvent<Date>) {
    if (this.customRangeEnd == event.value) return;

    this.customRangeEnd = event.value;
    await this.loadCustomRangeMetrics();
  }

  getTimeTravelled(metrics: any) {
    return this.domSanitizer.bypassSecurityTrustHtml(
      metrics.totalTimeTravelled
        .split(' ')
        .map((word: string, index: number) =>
          index % 2 === 1
            ? `<span style='font-variant: small-caps; font-size: 0.75em; font-weight: bold;'>${word}</span>`
            : word,
        )
        .join(' '),
    );
  }
}
